module.exports = "/images/slide-qs-t-12.jpg";